import { render, staticRenderFns } from "./DataMigrationView.vue?vue&type=template&id=c2c7e82e"
import script from "./DataMigrationView.vue?vue&type=script&lang=ts"
export * from "./DataMigrationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports